import { environment } from './environment';

export const baseUrl = environment.baseUrl;

export const endpoint = (path: string): string => {
  path = path.startsWith('/') ? path : `/${path}`;
  return !path ? environment.apiUrl : `${environment.apiUrl}${path}`.trim();
};

export const stripeApiKey = environment.stripe.publicKey;
